"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

exports.Cookies = _jsCookie.default;

var _reactTimeout = _interopRequireDefault(require("react-timeout"));

var _Link = _interopRequireDefault(require("../../navigation/Link/Link"));

var _P = _interopRequireDefault(require("../../typography/text/P"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const CookieConsent = ({
  children,
  buttonLabel,
  onAccept,
  setTimeout,
  ...otherProps
}) => {
  const [hiding, setHiding] = (0, _react.useState)(false);
  const [visible, setVisible] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    // If the cookie is undefined then show the cookie consent bar
    if (_jsCookie.default.get('cookie-consent') === undefined) {
      setVisible(true);
    }
  }, [setVisible]);
  const accept = (0, _react.useCallback)(() => {
    // Set a persistent cookie to hide the cookie consent bar
    _jsCookie.default.set('cookie-consent', true, {
      expires: 36500
    }); // Trigger the hiding animation


    setHiding(true); // Remove the element after the hiding animation has completed

    setTimeout(() => {
      setVisible(false);

      if (onAccept === 'function') {
        onAccept();
      }
    }, 1000);
  }, [setTimeout, onAccept]);
  if (!visible) return false;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CookieConsentWrapper, {
    hiding: hiding,
    ...otherProps,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
      hiding: hiding,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CookieConsentContent, {
        children: children
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Button, {
        primary: true,
        small: true,
        onClick: accept,
        children: buttonLabel
      })]
    })
  });
};

CookieConsent.propTypes = {
  buttonLabel: _propTypes.default.string,
  onAccept: _propTypes.default.func,
  children: _propTypes.default.node
};
CookieConsent.defaultProps = {
  buttonLabel: 'Dismiss',
  onAccept: undefined,
  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_P.default, {
    children: ["We use cookies to make it easier for you to use our website. By continuing to use our website, you consent to us using these cookies. Read our", ' ', /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.default, {
      href: "https://www.reassure.co.uk/cookie-policy",
      title: "View Cookie Policy",
      target: "_blank",
      children: "Cookie Policy"
    }), ' ', "to find out how you can adjust your browser's cookie settings."]
  })
};

var _default = (0, _reactTimeout.default)(CookieConsent);

exports.default = _default;